export const locale = {
    lang: 'pl',
    data: {
        'Date is required!': 'Dzień jest wymagany!',
        'Hour is required!': 'Godzina jest wymagana!',
        'Minute is required!': 'Minuta jest wymagana!',
        'Name is required!': 'Nazwa jest wymagana!',
        'Service is required!': 'Usługa jest wymagana!',
        'Customer is required!': 'Klient jest wymagany!',
        'Worker is required!': 'Pracownik jest wymagany!',
        'Description': 'Opis',
        'Reservation details': 'Dane rezerwacji',
        'DELETE': 'Usuń',
        'EDIT': 'Edycja',
        'SAVE': 'Zapisz',
        'Cancel': 'Anuluj',
        'CANCEL': 'Anuluj',
        'Confirm': 'Potwierdź',
        'Are you sure you want to left current window?': 'Czy na pewno chcesz opuścić bieżące okno?',
        'Confirm deletion': 'Potwierdź usunięcie',
        'Are you sure you want to delete selected message template?': 'Czy na pewno chcesz usunąć wybrany szablon wiadomości?',
        'Resource': 'Zasób',
        'Someone else has to confirm provided changes by scanning the card.': 'Inny pracownik musi zaakceptować zmiany poprzaez zeskanowanie swojej karty.',
        'Do you really want to confirm changes?': 'Czy na pewno chcesz zaakceptować zmiany?',
        'Are you sure you want to save provided data?': 'Czy zapisać wprowadzone zmiany?',
        'Acceptance has to be done by different user!': 'Akceptacji musi dokonać inny użytkownik!',
        'Confirm changes': 'Potwierdź zmiany',
    }
};
